import frequencyData from './frequency-data-live.json';

export function startMockFrequencyStream(onData, interval = 1000) {
  if (!Array.isArray(frequencyData) || !frequencyData.length) {
    return null;
  }

  let currentIndex = 0;

  const timer = window.setInterval(() => {
    onData(frequencyData[currentIndex]);
    currentIndex = (currentIndex + 1) % frequencyData.length;
  }, interval);

  return timer;
}

export function stopMockFrequencyStream(timer) {
  if (timer) {
    window.clearInterval(timer);
  }
}
